<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
// // import 'echarts-liquidfill';

export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    left2Data: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      // console.log(props)
      chart.init(props.left2Data, props.name, props.color);
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init() {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);
    const xData = ["未处理", "已处理"];
    const yData = [42, 202];
    const yData1 = [300, 300]; //背景框高度
    this.state.chart.setOption({
      tooltip: {
        show: true,
        formatter: (val) => {
          if (val.componentIndex === 0) {
            return `${val.name}&nbsp;&nbsp;${val.data}`;
          }
        },
      },
      grid: {
        top: "8%",
        bottom: "20%", //也可设置left和right设置距离来控制图表的大小
      },
      // x轴设置
      xAxis: {
        type: "category",
        data: xData,
        // x轴背景网格线
        splitLine: {
          show: false,
          lineStyle: {
            type: "dashed",
            color: "rgba(255,255,255 ,0.1)",
            width: 1,
          },
        },
        axisLabel: {
          margin: 20, // x轴标签与轴线距离
          fontSize: 16,
          color: "rgba(255, 255, 255, 0.5)",
        },
        // x轴标签
        axisTick: {
          show: false,
        },
        axisLine: {
          lineStyle: {
            color: "rgba(255,255,255 ,0.1)",
          },
        },
      },
      // y轴设置
      yAxis: {
        type: "value",
        // 标签
        axisLabel: {
          show: false,
        },
        // 坐标轴线
        axisLine: {
          show: false,
          lineStyle: {
            color: "rgba(255,255,255 ,0.1)",
          },
        },
        // 背景网格线
        splitLine: {
          show: false,
          lineStyle: {
            color: "rgba(255,255,255 ,0.1)",
          },
        },
        // y轴刻度
        axisTick: {
          show: false,
          length: 2,
          lineStyle: {
            width: 2,
            color: "rgba(255， 255， 255 ,1)",
          },
        },
      },
      series: [
        {
          label: {
            show: true, // 显示标签（即数值）
            position: "top", // 设置标签的位置，可选值有'top'、'bottom'、'inside'、'outside'
            formatter: "{c}",
            color: "#fff", // 格式化标签内容，{c}代表当前数据点的数值
          },
          // 中间重复的方块
          type: "pictorialBar",
          symbol: "rect",
          symbolSize: ["20%", 5],
          symbolRepeat: true,
          symbolMargin: 2,
          data: yData,
          z: 1,
          itemStyle: {
            color: "#19F1CA",
          },
        },
        {
          // 背景框
          type: "bar",
          barWidth: 20,
          data: yData1,
          z: 0,
          itemStyle: {
            borderWidth: 2,
            borderColor: "#12AA8F",
            color: "transparent",
          },
        },
      ],
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
